export default __webpack_public_path__ + "static/media/TranzitLogoV1.befb943a.png";